module.exports = __webpack_public_path__ + "static/img/t3.802b18d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/taijia/t3.png
// module id = ai7A
// module chunks = 1